import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/RegisterView.vue')
  },
  {
    path: '/expertise',
    name: 'expertise',
    component: () => import('../views/ExpertiseadistanceView.vue')
  },
  {
    path: '/medical',
    name: 'medical',
    component: () => import('../views/MedicalView.vue')
  },
  {
    path: '/apresvente',
    name: 'apresvente',
    component: () => import('../views/ServiceapresventeView.vue')
  },
  {
    path: '/dommages',
    name: 'dommages',
    component: () => import('../views/ServicedommagesView.vue')
  },
  {
    path: '/relationclient',
    name: 'relationclient',
    component: () => import('../views/ServicerelationclientView.vue')
  },
  {
    path: '/supporttechnique',
    name: 'supporttechnique',
    component: () => import('../views/SupporttechniqueView.vue')
  },
  {
    path: '/abonnements',
    name: 'abonnements',
    component: () => import('../views/NosabonnementsView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
